import {useStyles} from '../../../../../shared/hooks/styles';

export const useHistoryTabMobileStyles = () => {
  return useStyles(({theme}) => ({
    historyCardList: {
      marginTop: 0,
      shadowColor: theme.color.shaddowBg,
      shadowOffset: {
        width: 0,
        height: 4,
      },
      shadowRadius: 10,
      paddingVertical: 16,
      paddingHorizontal: 32,
      alignItems: 'flex-start',
      borderColor: theme.color.borderColor,
      borderWidth: 2,
      borderRadius: 5,
      backgroundColor: theme.color.primaryNonGreyBackground,
      elevation: 5,
    },
    historyCard: {
      marginTop: 10,
    },
    historyRow: {
      paddingVertical: 10,
      marginBottom: 10,
      borderBottomWidth: 1,
      borderColor: theme.color.borderColor,
    },
    historyName: {
      fontSize: 16,
      // fontWeight: '600',
      color: theme.color.textColor,
    },
  }));
};
